export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  categoryId: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  imageUrl: string;
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'art-1',
    title: '新手入门：如何挑选你的第一本正版同人志',
    slug: 'beginner-guide-first-doujinshi',
    excerpt: '刚入坑同人志收藏？这篇指南从画风判断、印刷品质、授权标识等方面，手把手教你挑选第一本正版同人志。',
    content: `<p>同人志（Doujinshi）是日本二次元文化中非常重要的一部分，指的是由个人或同人社团独立创作的漫画、小说、插画集等作品。对于刚接触同人志收藏的新手来说，面对琳琅满目的选择可能会感到不知所措。这篇指南将帮助你从零开始，建立自己的同人志收藏体系。</p>
    <h2>了解同人志的类型</h2>
    <p>正版同人志主要分为以下几类：原创同人志（完全自创的世界观和角色）、二次创作同人志（基于已有动漫、游戏IP的再创作）、插画集（以精美插画为主）、漫画同人志（以故事情节为主）。了解不同类型有助于你明确自己的收藏方向。</p>
    <h2>判断画风和品质</h2>
    <p>画风是选择同人志的首要因素。建议先在网上浏览作者的Pixiv、Twitter等社交账号，确认画风符合自己的审美。印刷品质方面，正版同人志通常使用较好的纸张和印刷工艺，封面有质感，内页色彩还原度高。</p>
    <h2>识别正版授权标识</h2>
    <p>购买时注意查看是否有正版授权标识。日本同人志通常会在版权页注明发行社团和印刷信息，正规渠道购买的同人志都会有明确的来源信息。避免购买来路不明的盗版翻印品，不仅品质差，也不利于支持创作者。</p>
    <h2>推荐购买渠道</h2>
    <p>国内推荐通过Melonbooks通贩、虎穴通贩的官方代理渠道购买，也可以通过ComicUp、CP等国内同人展现场选购。日本方面可以通过Melonbooks、虎之穴的线上商店或委托代购购买。注意选择信誉良好的代购服务，确保商品能安全送达。</p>`,
    categoryId: 'cat-1',
    categoryName: '正版同人志',
    author: '收藏达人小明',
    date: '2026-07-20',
    readTime: '8分钟',
    tags: ['新手入门', '同人志', '购买指南', '正版'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Beginner%20opening%20first%20doujinshi%20manga%20book%20with%20excitement%2C%20beautiful%20cover%20art%2C%20warm%20reading%20nook%20with%20soft%20lamp%20light%2C%20cozy%20atmosphere%2C%20Japanese%20style%20room%20decoration%2C%20clean%20composition%2C%20artistic%20photography&width=800&height=500&seq=art-1-img&orientation=landscape',
    featured: true,
  },
  {
    id: 'art-2',
    title: '鬼灭之刃官方设定集深度评测：值得收藏的艺术品',
    slug: 'demon-slayer-artbook-review',
    excerpt: '《鬼灭之刃》官方设定集不仅收录了海量精美插图，更有角色设计草稿和动画制作幕后，是粉丝不可错过的收藏佳品。',
    content: `<p>《鬼灭之刃》作为近年来现象级的动漫作品，其官方设定集的质量同样令人惊叹。本书不仅是一本普通的设定资料集，更是一件可以反复欣赏的艺术品。本次评测将从内容、印刷、装帧等多个维度进行全面分析。</p>
    <h2>内容概览</h2>
    <p>设定集收录了从第一季到剧场版无限列车篇的全部角色设定资料。每个主要角色都有详细的三视图、表情集和服装设计图，甚至连配角的细节都一丝不苟。除此之外，还有大量未公开的原画和分镜稿。</p>
    <h2>印刷与装帧品质</h2>
    <p>采用A4大开本设计，封面使用特殊烫金工艺，手感极佳。内页使用高克重铜版纸，色彩还原度极高，水之呼吸的蓝色和火之神神乐的红色都呈现出令人震撼的视觉效果。装订采用线装方式，即使反复翻阅也不易散页。</p>
    <h2>收藏价值分析</h2>
    <p>首版限定附赠特典明信片套装，目前已绝版，二手市场价格持续走高。对于鬼灭粉丝来说，这是一本兼具观赏性和收藏价值的设定集。建议趁现在还能以合理价格入手时尽快购买。</p>`,
    categoryId: 'cat-2',
    categoryName: '角色设定集',
    author: '二次元收藏家',
    date: '2026-07-15',
    readTime: '10分钟',
    tags: ['鬼灭之刃', '设定集', '评测', '收藏'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20official%20art%20book%20displayed%20on%20elegant%20wooden%20stand%2C%20open%20to%20beautiful%20character%20illustration%20page%2C%20warm%20ambient%20lighting%2C%20Japanese%20aesthetic%20setting%2C%20collector%20display%2C%20clean%20composition%2C%20high%20quality%20photography&width=800&height=500&seq=art-2-img&orientation=landscape',
    featured: true,
  },
  {
    id: 'art-3',
    title: 'ComicUp 30 参展全攻略：从抢票到扫本的终极指南',
    slug: 'comicup-30-guide',
    excerpt: '国内最大同人展ComicUp即将开幕！本文涵盖抢票技巧、展位攻略、扫本清单和必备物品，助你高效逛展。',
    content: `<p>ComicUp（简称CP）是国内规模最大的同人创作交流展会，每届都吸引数万名创作者和爱好者参与。CP30即将在上海举办，本文整理了一份从抢票到现场扫本的完整攻略，帮助你在人山人海中高效完成收藏目标。</p>
    <h2>抢票攻略</h2>
    <p>门票一般在开展前1-2个月开放预售。建议提前注册好购票平台账号，并绑定支付方式。开抢前5分钟进入页面等待刷新，抢票时选择非黄金时段（如上午晚些时候的场次）成功率更高。如果抢不到预售票，开展当天也有少量现场票发售。</p>
    <h2>展前准备</h2>
    <p>提前在CP官网查看摊位图和参展社团列表，标记想逛的摊位。建议制作一份"扫本清单"，按照摊位号排列，节省现场查找时间。必备物品包括：舒适的运动鞋、充足现金（部分摊位不支持移动支付）、折叠购物车（装战利品用）、充电宝。</p>
    <h2>现场扫本技巧</h2>
    <p>热门社团的作品通常开场2小时内就会售罄，建议优先前往。如果不是特别热门的摊位，可以在下午时段去，人较少且可能有折扣。记得带上名片或社交账号二维码，方便与创作者交流。</p>`,
    categoryId: 'cat-5',
    categoryName: '展会指南',
    author: '展会老司机',
    date: '2026-07-10',
    readTime: '12分钟',
    tags: ['ComicUp', '同人展', '参展攻略', '扫本'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Large%20anime%20comic%20convention%20hall%20with%20booths%20displaying%20doujinshi%20and%20art%2C%20colorful%20banners%2C%20enthusiastic%20crowd%20browsing%2C%20bright%20exhibition%20center%20lighting%2C%20energetic%20vibrant%20atmosphere%2C%20wide%20angle%20composition&width=800&height=500&seq=art-3-img&orientation=landscape',
    featured: false,
  },
  {
    id: 'art-4',
    title: '漫画创作入门：从分镜到完稿的完整流程',
    slug: 'manga-creation-tutorial',
    excerpt: '想画自己的漫画？本文从分镜设计、人物构图到线条处理，全面介绍漫画创作的基础流程和实用技巧。',
    content: `<p>漫画创作是一项需要综合能力的艺术形式。无论是想画同人志还是原创漫画，掌握基础创作流程都是必不可少的。本文将从分镜、构图、线条到后期处理，全面介绍漫画创作的核心步骤。</p>
    <h2>分镜设计</h2>
    <p>分镜（Name）是漫画的蓝图。好的分镜需要考虑页面翻页节奏、格子大小变化带来的视觉冲击力、以及对话框的合理布局。建议先用简单的草稿画出大致框架，反复调整直到故事节奏流畅。</p>
    <h2>人物与背景构图</h2>
    <p>人物姿态和表情是传达情感的关键。平时多练习人体速写，积累各种角度和动态的描绘能力。背景不需要过于复杂，但要符合场景设定，使用透视辅助线可以帮助画出准确的背景。</p>
    <h2>线条处理</h2>
    <p>不同粗细的线条能传达不同的质感和氛围。G笔尖适合画主线条和人物轮廓，圆笔尖适合细节描绘，学生笔尖适合背景和效果线。数字绘画中，调节笔压感应可以模拟传统蘸水笔的效果。</p>`,
    categoryId: 'cat-3',
    categoryName: '漫画手册',
    author: '漫画家之路',
    date: '2026-07-05',
    readTime: '15分钟',
    tags: ['漫画创作', '教程', '分镜', '绘画技巧'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Artist%20drawing%20manga%20on%20desk%20with%20tools%20and%20sketches%20scattered%2C%20warm%20desk%20lamp%20creating%20cozy%20atmosphere%2C%20pencil%20and%20inking%20tools%20visible%2C%20creative%20workspace%2C%20soft%20natural%20side%20light%2C%20clean%20artistic%20composition&width=800&height=500&seq=art-4-img&orientation=landscape',
    featured: false,
  },
  {
    id: 'art-5',
    title: '同人本防潮保存全攻略：让藏品历久弥新',
    slug: 'doujinshi-preservation-guide',
    excerpt: '同人本如何保存才能历久弥新？专业级防潮、防黄、防虫保存方法，让你的珍贵藏品永葆青春。',
    content: `<p>对于同人本收藏爱好者来说，如何妥善保存珍贵的藏品是一门必修课。纸张容易受潮变黄、受虫蛀，如果不采取正确的保存措施，精心收集的同人本可能在几年内就失去原有的品质。以下是专业的保存方案。</p>
    <h2>选择合适的保存袋</h2>
    <p>选用无酸、无PVC的PP材质保存袋是最基本的保护措施。常见规格有A5（适配大多数同人志）和B5（适配较大开本）。购买时注意选择食品级PP材质，避免塑化剂迁移导致纸张受损。</p>
    <h2>控制温湿度</h2>
    <p>书籍保存的理想温度为18-22°C，相对湿度45-55%。可以使用电子防潮箱或硅胶干燥剂来控制湿度。避免将同人本存放在阳光直射的地方，紫外线会加速纸张黄化。</p>
    <h2>摆放方式</h2>
    <p>同人本应竖直摆放，避免平放叠压导致书脊变形。如果书架空间不足需要叠放，建议不超过5本，且定期更换叠放顺序。使用书架分隔板保持书籍整齐，避免倾斜导致的变形。</p>`,
    categoryId: 'cat-6',
    categoryName: '收藏技巧',
    author: '收藏达人小明',
    date: '2026-06-28',
    readTime: '7分钟',
    tags: ['收藏技巧', '保存方法', '防潮', '养护'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20books%20carefully%20wrapped%20in%20protective%20plastic%20sleeves%20on%20organized%20bookshelf%2C%20humidity%20control%20device%20nearby%2C%20neat%20home%20library%20setting%2C%20warm%20soft%20indoor%20lighting%2C%20clean%20organized%20composition%2C%20professional%20preservation%20display&width=800&height=500&seq=art-5-img&orientation=landscape',
    featured: false,
  },
  {
    id: 'art-6',
    title: '2026年上半年最值得入手的限定手办Top10',
    slug: '2026-h1-figures-top10',
    excerpt: '汇总2026上半年发售的限定手办，从涂装品质、还原度到性价比全方位评测，帮你选出最值得入手的藏品。',
    content: `<p>2026年上半年各大厂商推出了众多令人心动的限定手办，从Good Smile Company到ALTER，品质各有千秋。本文精选了上半年最值得入手的10款手办，为你的收藏决策提供参考。</p>
    <h2>评选标准</h2>
    <p>我们的评选综合考虑了以下维度：涂装精细度（30%）、原型还原度（25%）、性价比（20%）、限定稀缺性（15%）、展示效果（10%）。所有入选产品均为实际到手后的真实评测。</p>
    <h2>Top 10 榜单亮点</h2>
    <p>本届榜首由ALTER出品的《Fate/Grand Order》斯卡哈限定版夺得，涂装精致度达到了业界顶级水平，肤色渐变自然，服装纹理清晰可见。第二名是GSC的初音未来2026雪初音限定版，透明材质的运用令人惊艳。</p>`,
    categoryId: 'cat-4',
    categoryName: '周边收藏',
    author: '手办猎人',
    date: '2026-06-20',
    readTime: '14分钟',
    tags: ['手办', '限定', '评测', '收藏推荐'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20anime%20figures%20displayed%20in%20glass%20cabinet%20with%20elegant%20lighting%2C%20detailed%20character%20figurines%20on%20acrylic%20stands%2C%20collector%20room%20setting%2C%20warm%20ambient%20spotlight%2C%20museum%20quality%20display%2C%20clean%20professional%20composition&width=800&height=500&seq=art-6-img&orientation=landscape',
    featured: true,
  },
  {
    id: 'art-7',
    title: 'Melonbooks vs 虎之穴：两大同人通贩平台对比',
    slug: 'melonbooks-vs-toranoana',
    excerpt: '日本两大同人志通贩平台详细对比：商品丰富度、国际配送、价格和用户体验全方位评测。',
    content: `<p>Melonbooks（蜜瓜）和虎之穴（Toranoana）是日本最大的两家同人志通贩平台。对于海外收藏者来说，选择哪个平台购买同人志是一个重要的决策。本文将从多个维度对比两大平台。</p>
    <h2>商品丰富度</h2>
    <p>虎之穴在整体商品数量上略胜一筹，尤其是在女性向同人志方面有压倒性优势。Melonbooks则在男性向和一般向同人志方面更加均衡。两家平台都有独家的委托销售作品，部分同人志只在其中一家销售。</p>
    <h2>国际配送</h2>
    <p>虎之穴支持国际直邮，使用EMS配送，通常7-14天送达。Melonbooks需要通过转运服务购买，增加了额外的转运费用和时间。对于海外用户来说，虎之穴的直邮服务更加便捷。</p>`,
    categoryId: 'cat-1',
    categoryName: '正版同人志',
    author: '海淘老手',
    date: '2026-06-15',
    readTime: '9分钟',
    tags: ['Melonbooks', '虎之穴', '通贩', '海淘'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Japanese%20doujinshi%20online%20shopping%20website%20displayed%20on%20laptop%20screen%2C%20colorful%20book%20covers%20grid%20view%2C%20modern%20clean%20desk%20setup%2C%20warm%20indoor%20lighting%2C%20e-commerce%20browsing%20scene%2C%20clean%20professional%20composition&width=800&height=500&seq=art-7-img&orientation=landscape',
    featured: false,
  },
  {
    id: 'art-8',
    title: '从零开始学板绘：数位板选购与入门教程',
    slug: 'digital-art-tablet-guide',
    excerpt: '想开始板绘创作？从Wacom到国产数位板，对比不同价位产品的优劣，附带新手入门练习指南。',
    content: `<p>数字绘画（板绘）已经成为漫画和插画创作的主流方式。对于想要入门的新手来说，选择一款合适的数位板是第一步。本文将帮你了解不同价位数位板的特点，并提供入门练习建议。</p>
    <h2>数位板选购指南</h2>
    <p>入门级推荐Wacom Intuos系列或国产绘王（Huion）H610系列，价格在300-600元区间，性价比高。中端推荐Wacom Intuos Pro或XP-Pen Artist系列。专业级则推荐Wacom Cintiq屏板一体机，但价格较高。</p>
    <h2>入门练习方法</h2>
    <p>建议从线条练习开始：直线、曲线、S形线，每天练习15-30分钟。然后进行临摹练习，从简单的几何体到复杂的人物角色。最重要的是保持每天练习的习惯，板绘的手眼协调需要时间适应。</p>`,
    categoryId: 'cat-3',
    categoryName: '漫画手册',
    author: '板绘教练',
    date: '2026-06-08',
    readTime: '11分钟',
    tags: ['板绘', '数位板', '教程', '入门'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20drawing%20tablet%20on%20clean%20modern%20desk%20with%20stylus%20pen%2C%20illustration%20software%20on%20monitor%20showing%20anime%20style%20artwork%2C%20warm%20desk%20lighting%2C%20creative%20workspace%2C%20minimal%20clean%20composition%2C%20professional%20artist%20setup&width=800&height=500&seq=art-8-img&orientation=landscape',
    featured: false,
  },
  {
    id: 'art-9',
    title: 'Comic Market 105 参展回顾：冬日圣战的感动',
    slug: 'comiket-105-review',
    excerpt: '回顾Comic Market 105的精彩瞬间，分享热门社团作品和现场氛围，为下次参展做准备。',
    content: `<p>Comic Market（Comiket）是世界上最大的同人志即卖会，每年在东京国际展示场（Big Sight）举办两届。C105于2026年冬季举办，为期两天吸引了超过50万人次参观。以下是本次展会的回顾和心得。</p>
    <h2>展会规模</h2>
    <p>C105共计约35000个社团参展，分布在东馆和西馆。热门IP如《原神》、《蔚蓝档案》、《赛马娘》的同人志数量显著增长，反映出当下二次元文化的最新趋势。</p>
    <h2>热门社团作品推荐</h2>
    <p>本次展会中，以细腻水彩画风著称的社团"水鏡堂"推出的原神同人插画集在开场30分钟内售罄。另外，以剧情向同人漫画见长的"星屑工房"的新作也获得了极高的评价。</p>`,
    categoryId: 'cat-5',
    categoryName: '展会指南',
    author: '展会老司机',
    date: '2026-05-30',
    readTime: '13分钟',
    tags: ['Comiket', '展会回顾', '日本', '同人志'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Tokyo%20Big%20Sight%20comic%20market%20exterior%20with%20crowds%20of%20attendees%2C%20colorful%20cosplay%20in%20background%2C%20bright%20winter%20sky%2C%20iconic%20architecture%2C%20energetic%20festival%20atmosphere%2C%20wide%20angle%20view%2C%20clean%20composition&width=800&height=500&seq=art-9-img&orientation=landscape',
    featured: true,
  },
  {
    id: 'art-10',
    title: '同人本收藏的社交价值：如何建立你的收藏朋友圈',
    slug: 'doujinshi-social-community',
    excerpt: '同人本收藏不只是个人爱好，更是连接志同道合朋友的纽带。教你如何参与社群、分享收藏。',
    content: `<p>收藏同人本不仅是一种个人爱好，更是一种社交方式。通过分享和交流收藏心得，你可以结识志同道合的朋友，甚至找到一起逛展的伙伴。本文将介绍如何构建你的同人本收藏社交圈。</p>
    <h2>线上社群平台</h2>
    <p>微博超话和Lofter是国内同人爱好者最活跃的平台。加入相关超话，发布你的收藏展示帖，使用合适的标签，很快就能找到同好。B站的收藏类UP主也经常组织粉丝群，是结识朋友的好渠道。</p>
    <h2>线下活动参与</h2>
    <p>参加同人展不仅是购物的机会，更是面对面的社交场合。很多社团的摊主都乐于和读者交流，可以借此机会认识创作者和其他收藏者。一些城市还有定期的同人本交换会和读书会，是不错的线下社交活动。</p>`,
    categoryId: 'cat-6',
    categoryName: '收藏技巧',
    author: '社群小达人',
    date: '2026-05-22',
    readTime: '6分钟',
    tags: ['社交', '社群', '同好', '分享'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Friends%20gathering%20around%20table%20sharing%20and%20discussing%20doujinshi%20manga%20books%2C%20warm%20cafe%20setting%20with%20soft%20lighting%2C%20enthusiastic%20conversation%2C%20colorful%20book%20covers%20on%20table%2C%20cozy%20social%20atmosphere%2C%20clean%20composition&width=800&height=500&seq=art-10-img&orientation=landscape',
    featured: false,
  },
  {
    id: 'art-11',
    title: 'EVA新剧场版全设定集套装开箱：跨越二十年的感动',
    slug: 'eva-artbook-collection',
    excerpt: '《新世纪福音战士新剧场版》全系列设定集套装开箱评测，超2000页的内容，EVA粉丝终极收藏。',
    content: `<p>《新世纪福音战士》是日本动画史上最具影响力的作品之一。随着新剧场版系列的完结，官方推出了全设定集套装，收录了从《序》到《终》四部剧场版的全部设定资料。这套装帧精美的设定集是EVA粉丝的梦想收藏。</p>
    <h2>套装内容</h2>
    <p>套装包含四本设定集，每本对应一部剧场版，共计超过2000页内容。另有特典收纳盒、复制原画卡和制作人员访谈小册子。收纳盒采用黑色哑光材质，印有初号机的剪影，设计简约而富有质感。</p>
    <h2>内容亮点</h2>
    <p>每本设定集都包含角色设定、机械设定（EVA机体和使徒）、背景美术、Layout原图以及庵野秀明监督的创作笔记。特别是《终》的设定集，收录了大量从未公开的概念设计和结局废弃方案，对于了解创作过程极为珍贵。</p>`,
    categoryId: 'cat-2',
    categoryName: '角色设定集',
    author: '二次元收藏家',
    date: '2026-05-15',
    readTime: '10分钟',
    tags: ['EVA', '设定集', '开箱', '新世纪福音战士'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Evangelion%20complete%20art%20book%20box%20set%20displayed%20elegantly%20on%20dark%20wooden%20surface%2C%20four%20books%20in%20sleeve%20case%2C%20dramatic%20side%20lighting%2C%20collector%20premium%20presentation%2C%20minimal%20Japanese%20aesthetic%2C%20clean%20sophisticated%20composition&width=800&height=500&seq=art-11-img&orientation=landscape',
    featured: true,
  },
  {
    id: 'art-12',
    title: '动漫周边投资指南：哪些限定品最具升值潜力',
    slug: 'anime-merch-investment',
    excerpt: '动漫周边不仅是爱好，也可以是有潜力的收藏投资。分析影响周边升值的因素，推荐值得关注的品类。',
    content: `<p>随着二次元文化的全球普及，稀有动漫周边的收藏价值持续攀升。一些限定品在几年内的升值幅度甚至超过了传统投资品。本文将从投资角度分析动漫周边的升值潜力，帮助你做出更明智的收藏决策。</p>
    <h2>影响升值的核心因素</h2>
    <p>稀缺性是决定升值空间的首要因素。生产数量少、发售渠道有限的限定品最具潜力。其次是IP热度，长青IP（如EVA、高达、龙珠）的周边通常比短期热门作品更具长期升值空间。制作厂商的声誉也很重要，ALTER、GSC等一线厂商的产品品质保证会提升收藏价值。</p>
    <h2>推荐关注品类</h2>
    <p>1/7或1/8比例的限定手办是目前升值最稳定的品类，特别是初版限定配色款。原画复制原稿和设定集签名版也是高价值收藏品。此外，Comiket限定同人志如果作者后来成为知名漫画家，早期同人本的价值会飙升。</p>`,
    categoryId: 'cat-4',
    categoryName: '周边收藏',
    author: '手办猎人',
    date: '2026-05-08',
    readTime: '11分钟',
    tags: ['投资', '升值', '限定品', '收藏价值'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Rare%20limited%20edition%20anime%20figures%20in%20glass%20display%20case%20with%20price%20tags%2C%20collector%20investment%20theme%2C%20museum%20quality%20lighting%2C%20premium%20collectibles%20presentation%2C%20sophisticated%20gallery%20setting%2C%20clean%20professional%20composition&width=800&height=500&seq=art-12-img&orientation=landscape',
    featured: false,
  },
];

export const faqs = [
  {
    question: '什么是同人志？和商业漫画有什么区别？',
    answer: '同人志（Doujinshi）是由个人或同人社团独立创作、自费出版的漫画、小说或插画集。区别于商业漫画，同人志的创作更加自由，不受出版社的商业限制，可以基于已有作品的二次创作，也可以是全新的原创作品。同人志通常印刷数量较少，但画风和内容都极具个性和特色。',
  },
  {
    question: '如何辨别正版和盗版同人志？',
    answer: '辨别正版同人志可以从以下几个方面入手：1）查看版权页是否标注了社团名称和发行信息；2）正版同人志的纸张和印刷品质通常较好，色彩鲜艳且均匀；3）通过正规渠道（如Melonbooks、虎之穴等通贩平台或官方代理）购买；4）价格异常低廉的"同款"很可能是盗版翻印品；5）部分正版同人志会在封面或内页印有防伪标识。',
  },
  {
    question: '同人本应该如何保存才能防止发黄和受潮？',
    answer: '保存同人本的关键是控制环境：1）使用无酸PP材质保存袋单独封装每本同人本；2）存放在温度18-22°C、湿度45-55%的环境中，可使用防潮箱或干燥剂；3）避免阳光直射和荧光灯长时间照射；4）竖直摆放，避免叠压；5）定期（每3-6个月）检查一次是否有霉变或虫蛀迹象。',
  },
  {
    question: '国内有哪些可以买到正版同人志的渠道？',
    answer: '国内购买正版同人志的主要渠道包括：1）同人展会现场购买（如ComicUp、CP等）；2）Melonbooks和虎之穴的官方代理或代购渠道；3）淘宝和闲鱼上的信誉代购卖家（注意甄别盗版）；4）B站会员购偶尔会代理一些正版同人商品；5）一些线下的动漫专门店也会少量进货。',
  },
  {
    question: '新手收藏同人本应该从哪里开始？',
    answer: '对于新手，建议从以下步骤开始：1）确定你最喜欢的动漫IP或画师，缩小范围；2）在Pixiv、Twitter等平台关注喜欢的画师，了解他们的同人活动；3）从价格适中（50-150元）的单本同人志开始尝试；4）参加一次本地的同人展会，现场体验选购的乐趣；5）加入同好社群，向前辈请教收藏经验。',
  },
  {
    question: 'ComicUp和Comiket有什么不同？',
    answer: 'ComicUp（CP）是中国上海举办的大型同人展，以中文原创和二次创作为主，氛围友好且适合新人。Comiket（Comic Market）是日本东京举办的全球最大同人志即卖会，规模更大（约35000个摊位），以日文作品为主，国际化程度高。CP更适合国内收藏者入门，Comiket则是进阶收藏者的朝圣之地。',
  },
];